
import {Container,Title,Content} from './styled';

export function OptionMenu(props){
  return(
    <Container>
      <Title/>
      <Content>
        <li/>
      </Content>
    </Container>
  );  
}